<template>
    <a v-if="target === '_blank'" :target="target" :href="href">{{ text }}</a>
    <Link v-else :href="href">{{ text }}</Link>
</template>

<script>
export default {
    name: "NavLink",
    props: {
        href: {
            type: String,
        },
        text: {
            type: String,
        },
        type: {
            type: String,
            default: "external_link",
        },
    },
    computed: {
        target() {
            return this.type === "external_link" ? "_blank" : "self";
        },
    },
};
</script>

<style scoped></style>
